import { render, staticRenderFns } from "./customerPopup.vue?vue&type=template&id=172f715a&"
import script from "./customerPopup.vue?vue&type=script&lang=js&"
export * from "./customerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172f715a')) {
      api.createRecord('172f715a', component.options)
    } else {
      api.reload('172f715a', component.options)
    }
    module.hot.accept("./customerPopup.vue?vue&type=template&id=172f715a&", function () {
      api.rerender('172f715a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/customerPopup.vue"
export default component.exports